<template>
  <kst-section items-mode>
    <kst-table view-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="DispatchID"
        :label="RinvItemCatalog.DispatchID.ColumnLabel"
      >
        <kst-value :field="column.field" :data="row" :catalog="RinvItemCatalog"/>
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.RelatedList.getItemInfo(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging"
        field="Packaging"
        :label="RinvItemCatalog.Packaging.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="RinvItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="Quantity"
        :label="RinvItemCatalog.Quantity.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="RinvItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="SellPrice"
        :label="RinvItemCatalog.SellPrice.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="RinvItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-subtotal"
        field="Total"
        :label="RinvItemCatalog.Total.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="RinvItemCatalog"/>
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import Model from "../RinvModel.js";
import RinvItemCatalog from "../RinvItemCatalog.js";

export default {
  props: {
    items: Array
  },
  data: () => ({
    Model: Model,
    RinvItemCatalog: RinvItemCatalog
  })
}
</script>